import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { RedirectEmptyPage } from './RedirectEmptyPage'
import { useMixpanelPageview } from 'business-logic/tracking/mixpanel'
import { useExperiments } from 'business-logic/experiments'
import { RunningExperiments } from 'RunningExperiments'
//TODO - Loading page, catch all page

const AdvertorialChunkRoutes = lazy(() => import(/* webpackChunkName: "advertorial" */ './pages/RoutesAdvertorial' ))
const AdvertorialRoutes = () => (
  <Suspense fallback={<div />}>
    <AdvertorialChunkRoutes />
  </Suspense>
)

const CheckoutChunkRoutes = lazy(() => import(/* webpackChunkName: "checkout" */ './pages/RoutesCheckout' ))
const CheckoutRoutes = () => (
  <Suspense fallback={<div />}>
    <CheckoutChunkRoutes />
  </Suspense>
)

const UpsellChunkRoutes = lazy(() => import(/* webpackChunkName: "upsell", webpackPrefetch: true */ './pages/RoutesUpsell'))
const UpsellRoutes = () => (
  <Suspense fallback={<div />}>
    <UpsellChunkRoutes />
  </Suspense>
)

const VideoLandingChunkRoutes = lazy(() => import(/* webpackChunkName: "video" */ './pages/RoutesVideo'))
const VideoRoutes = () => (
  <Suspense fallback={<div />}>
    <VideoLandingChunkRoutes />
  </Suspense>
)

const LazyRewardsChunkRoutes = lazy(() => import(/* webpackChunkName: "rewards" */ './pages/RoutesRewards'))
const OffersRoutes = () => (
  <Suspense fallback={<div />}>
    <LazyRewardsChunkRoutes />
  </Suspense>
)
const LazyVerticalChunkRoutes = lazy(() => import(/* webpackChunkName: "verticals" */ './pages/RoutesVerticals'))
const VerticalRoutes = () => (
  <Suspense fallback={<div />}>
    <LazyVerticalChunkRoutes />
  </Suspense>
)

export const AppRoutes  = () => {
  useExperiments(
    RunningExperiments.FORM_TYPE,
    [
      { name: 'a/step', weight: 50 },
      { name: 'b/appearing', weight: 50 },
    ]
  )
  useMixpanelPageview()

  return (

    <Routes>
      <Route element={
        <Routes>
          <Route element={<AdvertorialRoutes />} path={'news/*'} />
          <Route element={<CheckoutRoutes />} path="checkout/*" />
          <Route element={<UpsellRoutes />} path="upsell/*" />
          <Route element={<OffersRoutes />} path="rewards/*" />
          <Route element={<VideoRoutes />} path="video/*" />
          <Route element={<VerticalRoutes />} path="vertical/*" />
          <Route element={<RedirectEmptyPage />}  path="*"/>
        </Routes>
      } path="/:NAMESPACE/*" />
      {/*
        started off as offers, then changed to free, v6 does not support arrays for path so this,
        could build it dynamically but this also works.
      */}
    </Routes>
  )
}

